import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Typography } from '@mui/material';
import type { MouseEvent } from 'react';
import { IMG } from '../theme/assets';

/**
 * アイテムカード用のサムネイル・ヘッダー（案D：背景にサムネ＋タイトル白抜き）。
 * サムネ未取得時は種別イラストのグラデ背景でフォールバック。
 */
export default function ItemCardThumbHeader({
  thumb,
  isVideo,
  title,
  height = 100,
  onMenu,
}: {
  thumb?: string;
  isVideo: boolean;
  title: string;
  height?: number;
  onMenu?: (e: MouseEvent<HTMLElement>) => void;
}) {
  return (
    <Box sx={{ position: 'relative', height, overflow: 'hidden', flexShrink: 0 }}>
      {thumb ? (
        <Box
          component="img"
          src={thumb}
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: isVideo ? 'center' : 'top',
            filter: 'brightness(0.5)',
          }}
        />
      ) : (
        // サムネ無し：グラデ背景＋右下に薄いアイコン（landing-f 準拠）
        <Box
          sx={{
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            background: isVideo
              ? 'radial-gradient(120% 110% at 28% 8%, #38406a, #0c0f1c)'
              : 'radial-gradient(120% 110% at 28% 8%, #3a4a63, #12161f)',
          }}
        >
          <Box
            component="img"
            src={isVideo ? IMG.item.video : IMG.item.document}
            alt=""
            sx={{
              position: 'absolute',
              right: -8,
              bottom: -10,
              width: 118,
              height: 118,
              objectFit: 'contain',
              opacity: 0.22,
              transform: 'rotate(-8deg)',
            }}
          />
        </Box>
      )}

      {/* 種別バッジ */}
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          fontSize: 10,
          fontWeight: 800,
          color: '#fff',
          backgroundColor: 'rgba(0,0,0,.55)',
          borderRadius: 0.75,
          px: 0.85,
          py: '2px',
        }}
      >
        {isVideo ? '🎬 動画' : '📄 PDF'}
      </Box>

      {onMenu && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onMenu(e);
          }}
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            color: '#fff',
            zIndex: 2,
            '&:hover': { backgroundColor: 'rgba(255,255,255,.15)' },
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      )}

      {/* タイトル（白抜き） */}
      <Typography
        sx={{
          position: 'absolute',
          left: 12,
          right: onMenu ? 36 : 12,
          bottom: 8,
          color: '#fff',
          fontWeight: 800,
          fontSize: 13.5,
          lineHeight: 1.3,
          textShadow: '0 1px 5px rgba(0,0,0,.7)',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
